// snackbarStore.js
import { create } from 'zustand';

// Create a store for snackbar state
const useFollowUpSnackbarStore = create((set) => ({
  open: false,
  message: '',
  repair_id: '',
  repair_num: '',
  date: '',
  // new, add customer info
  customer_id: '',
  customer_name: '',
  customer_phone: '',
  
  // Show the snackbar
  showSnackbar: ({repair_id, repair_num, date, message, customer_id, customer_name, customer_phone}) => 
    set({ open: true, message, repair_id, repair_num, date, customer_id, customer_name, customer_phone }),
  
  // Hide the snackbar
  hideSnackbar: () => set({ open: false, message: '', repair_id: '', repair_num: '', date: '', customer_id: '', customer_name: '' }),
}));

export default useFollowUpSnackbarStore;
